module.exports = __webpack_public_path__ + "static/media/download3.ff297575.png";